<mat-sidenav-container class="sidenav-container">

  <!-- SIDENAV -->
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isSmall$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isSmall$ | async) ? 'over' : 'side'" [opened]="false">
    <mat-toolbar class="sideToolbar"><span class="menuTitle">Menu</span>
      <span class="fill-space"></span>
      <mat-icon aria-hidden="false" aria-label="Example close icon" (click)="drawer.close()">close</mat-icon>
    </mat-toolbar>
    <mat-nav-list>
      <a class="sideNavLink" mat-list-item routerLink="/home" routerLinkActive="active"
        (click)="drawer.close()">Home</a>
      <a class="sideNavLink" mat-list-item routerLink="/about" routerLinkActive="active"
        (click)="drawer.close()">About</a>
      <a class="sideNavLink" mat-list-item routerLink="/testimonials" routerLinkActive="active"
        (click)="drawer.close()">Testimonials</a>
      <a class="sideNavLink" mat-list-item routerLink="/plan-management" routerLinkActive="active"
        (click)="drawer.close()">Plan Management</a>
      <a class="sideNavLink" mat-list-item routerLink="/service-agreement" routerLinkActive="active"
        (click)="drawer.close()">Service Agreement</a>
      <a class="sideNavLink" mat-list-item routerLink="/contact" routerLinkActive="active"
        (click)="drawer.close()">Contact</a>
      <hr />
      <a class="sideNavLink" mat-list-item routerLink="/make-a-complaint" routerLinkActive="active"
        (click)="drawer.close()">Make a complaint</a>
      <a class="sideNavLink" mat-list-item routerLink="/privacy-policy" routerLinkActive="active"
        (click)="drawer.close()">Privacy Policy</a>
    </mat-nav-list>
  </mat-sidenav>

  <!-- CONTENT -->
  <mat-sidenav-content>

    <div class="topSpacer"></div>

    <!-- TOP TOOLBAR-->
    <mat-toolbar #navBar class="navbar">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isSmall$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>

      <span *ngIf="isSmall$ | async" class="fill-space"></span>

      <div class="logo1" routerLink="/">

        <img #logoSvg class="logoSvg" src="../../assets/svg/person_icon_white.svg" alt="logo">

        <div class="logoText">ADIEM</div>

      </div>

      <span class="fill-space"></span>
      <nav *ngIf="(isSmall$ | async) === false">
        <a mat-button routerLink="/home" routerLinkActive="mainMenuActive">Home</a>
        <a mat-button routerLink="/about" routerLinkActive="mainMenuActive">About</a>
        <a mat-button routerLink="/plan-management" routerLinkActive="mainMenuActive">Plan Management</a>
        <a mat-button routerLink="/service-agreement" routerLinkActive="mainMenuActive">Service Agreement</a>
        <a mat-button routerLink="/contact" routerLinkActive="mainMenuActive">Contact</a>
      </nav>

      <!-- DROPDOWN MENU -->
      <div class="rightNavSpacer" *ngIf="isSmall$ | async"></div>

    </mat-toolbar>

    <!-- TRANSCLUSION -->
    <ng-content #body></ng-content>
    <footer></footer>
  </mat-sidenav-content>
</mat-sidenav-container>